if (!customElements.get('bs-proyecto')) customElements.define('bs-proyecto', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-bs-proyecto-abrir]');
    if (!this.dialog?.showModal || !this.trigger) return;
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.slug = this.closest('[data-bs-slug]')?.dataset.bsSlug || '';
    this.trigger.setAttribute('role', 'button');
    this.trigger.setAttribute('aria-haspopup', 'dialog');
    this.trigger.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.abrir();
    }, { signal });
    this.trigger.addEventListener('keydown', event => {
      if (event.key !== ' ') return;
      event.preventDefault();
      this.trigger.click();
    }, { signal });
    this.querySelector('[data-bs-proyecto-cerrar]').addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('click', event => {
      if (event.target === this.dialog) {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        return;
      }
      if (event.target.closest('[data-bs-proyecto-video]')) this.alternarVideo();
    }, { signal });
    this.dialog.addEventListener('close', () => {
      const video = this.querySelector('video');
      if (video) { video.pause(); video.currentTime = 0; }
      if (this.slug && location.hash === `#${this.slug}`) history.replaceState(history.state, '', location.pathname + location.search);
      if (this.isConnected) this.trigger.focus({ preventScroll: true });
    }, { signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.querySelector('video')?.pause();
    }, { signal });
    if (this.slug && location.hash === `#${this.slug}`) requestAnimationFrame(() => this.abrir());
  }

  abrir() {
    const template = this.querySelector('[data-bs-proyecto-plantilla]');
    const medium = this.querySelector('[data-bs-proyecto-medio]');
    if (template && medium && !medium.firstElementChild) medium.append(template.content.cloneNode(true));
    const origen = this.trigger.getBoundingClientRect();
    this.dialog.showModal();
    /* La ficha crece desde la tarjeta que la abrió y vuelve a ella al cerrar */
    const caja = this.dialog.getBoundingClientRect();
    this.dialog.style.setProperty('--bs-origen', `${Math.round(origen.left + origen.width / 2 - caja.left)}px ${Math.round(origen.top + origen.height / 2 - caja.top)}px`);
    if (this.slug) history.replaceState(history.state, '', `#${this.slug}`);
    this.iniciarVideo();
  }

  iniciarVideo() {
    const video = this.querySelector('video');
    const control = this.querySelector('[data-bs-proyecto-video]');
    if (!video || !control) return;
    control.hidden = false;
    const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData;
    if (quieto) { this.marcarVideo(false); return; }
    video.muted = true;
    video.play().then(() => this.marcarVideo(true), () => this.marcarVideo(false));
  }

  alternarVideo() {
    const video = this.querySelector('video');
    if (!video) return;
    if (video.paused) video.play().then(() => this.marcarVideo(true), () => this.marcarVideo(false));
    else { video.pause(); this.marcarVideo(false); }
  }

  marcarVideo(reproduciendo) {
    const control = this.querySelector('[data-bs-proyecto-video]');
    if (!control) return;
    control.setAttribute('aria-label', reproduciendo ? 'Pausar video' : 'Reproducir video');
    control.querySelector('[data-bs-icono-pausa]').hidden = !reproduciendo;
    control.querySelector('[data-bs-icono-play]').hidden = reproduciendo;
  }

  disconnectedCallback() {
    this.querySelector('video')?.pause();
    this.abort?.abort();
    if (this.dialog?.open) this.dialog.close();
  }
});
